module.exports = __webpack_public_path__ + "assets/img/226201.209776e5.png";